import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Icons } from '@vex/icons/icons';

@Component({
  selector: 'vex-confirm-cancel-deployment',
  templateUrl: './confirm-cancel-deployment.component.html'
  // styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmCancelDeploymentComponent extends Icons implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmCancelDeploymentComponent>,
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onDismiss(){
    this.dialogRef.close();
  }

  onConfirm(val): void {
    this.dialogRef.close(val);
  }

}
